/**
 * Bracelet Calculator JavaScript
 * Handles form submission, zodiac/purpose-based recommendations, and result display
 */

document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('bracelet-calculator');
  const tabs = document.querySelectorAll('.calc-tab');
  const methods = document.querySelectorAll('.calculator-form__method');
  const checkboxes = document.querySelectorAll('input[name="purposes"]');

  // Bracelet data by zodiac
  const zodiacData = {
    'aries': { bracelets: ['protection', 'success'], primary: 'Red Jasper & Carnelian Bracelet', benefits: 'Courage, Energy, Protection' },
    'taurus': { bracelets: ['money', 'peace'], primary: 'Rose Quartz & Green Aventurine Bracelet', benefits: 'Stability, Abundance, Love' },
    'gemini': { bracelets: ['success', 'peace'], primary: 'Tiger Eye & Citrine Bracelet', benefits: 'Communication, Focus, Balance' },
    'cancer': { bracelets: ['love', 'peace'], primary: 'Moonstone & Pearl Bracelet', benefits: 'Emotional Balance, Intuition, Protection' },
    'leo': { bracelets: ['success', 'money'], primary: 'Citrine & Tiger Eye Bracelet', benefits: 'Confidence, Leadership, Prosperity' },
    'virgo': { bracelets: ['health', 'peace'], primary: 'Amethyst & Green Aventurine Bracelet', benefits: 'Healing, Clarity, Balance' },
    'libra': { bracelets: ['love', 'peace'], primary: 'Rose Quartz & Lapis Lazuli Bracelet', benefits: 'Harmony, Love, Balance' },
    'scorpio': { bracelets: ['protection', 'success'], primary: 'Black Tourmaline & Obsidian Bracelet', benefits: 'Protection, Transformation, Power' },
    'sagittarius': { bracelets: ['success', 'money'], primary: 'Turquoise & Citrine Bracelet', benefits: 'Luck, Wisdom, Adventure' },
    'capricorn': { bracelets: ['money', 'success'], primary: 'Garnet & Black Onyx Bracelet', benefits: 'Discipline, Success, Grounding' },
    'aquarius': { bracelets: ['peace', 'success'], primary: 'Aquamarine & Amethyst Bracelet', benefits: 'Innovation, Clarity, Intuition' },
    'pisces': { bracelets: ['peace', 'love'], primary: 'Amethyst & Moonstone Bracelet', benefits: 'Intuition, Compassion, Spiritual Growth' }
  };

  // Bracelet data by purpose
  const braceletData = {
    'money': {
      name: 'Raw Pyrite Bracelet for Wealth',
      crystals: 'Pyrite',
      benefits: 'Attracts wealth, business success, and financial abundance',
      handle: 'raw-pyrite-bracelet-for-wealth'
    },
    'love': {
      name: 'Rose Quartz Stone Bracelet',
      crystals: 'Rose Quartz',
      benefits: 'Opens heart chakra, attracts love, heals emotional wounds',
      handle: 'rose-quartz-stone-bracelet'
    },
    'protection': {
      name: 'Karungali Bracelet',
      crystals: 'Natural Ebony Wood (Karungali)',
      benefits: 'Shields from negative energy, evil eye protection, grounding',
      handle: 'karungali-bracelet-natural-ebony-wood-beads-govt-certified'
    },
    'health': {
      name: 'Karungali Bracelet',
      crystals: 'Natural Ebony Wood (Karungali)',
      benefits: 'Promotes healing, reduces stress, boosts immunity',
      handle: 'karungali-bracelet-natural-ebony-wood-beads-govt-certified'
    },
    'success': {
      name: 'Money Magnet Bracelet',
      crystals: 'Pyrite, Tiger Eye, Citrine, Aventurine',
      benefits: 'Builds confidence, attracts success, enhances willpower',
      handle: 'money-magnet-bracelet-with-pyrite-tiger-eye-citrine-aventurine-beads'
    },
    'peace': {
      name: 'Karungali Damru Bracelet with Rudraksha',
      crystals: 'Karungali, Rudraksha',
      benefits: 'Calms mind, aids meditation, promotes restful sleep',
      handle: 'karungali-damru-bracelet-with-rudraksha'
    }
  };

  const purposeLabels = {
    'money': 'Wealth & Abundance',
    'love': 'Love & Relationships',
    'protection': 'Protection & Shielding',
    'health': 'Health & Healing',
    'success': 'Success & Confidence',
    'peace': 'Peace & Calm'
  };

  // Initialize location autocomplete
  Calculator.initLocationAutocomplete(['calc-pob', 'calc-pob-purpose']);

  // Initialize tab switching
  Calculator.initTabs(tabs, methods, {
    dob: ['calc-dob', 'calc-dob-purpose'],
    tob: ['calc-tob', 'calc-tob-purpose'],
    pob: ['calc-pob', 'calc-pob-purpose']
  }, 'bracelet');

  // Limit checkbox selection to 3
  checkboxes.forEach(cb => {
    cb.addEventListener('change', function() {
      const checked = document.querySelectorAll('input[name="purposes"]:checked');
      if (checked.length > 3) {
        this.checked = false;
        alert('You can select up to 3 purposes only');
      }
    });
  });

  // Form submission
  form.addEventListener('submit', async function(e) {
    e.preventDefault();

    // Set button to loading state
    Calculator.setSubmitButtonState(true);

    // Get active method
    const activeMethod = document.querySelector('.calc-tab.active').dataset.method;

    // Collect form data for validation
    const formData = {
      name: document.getElementById('calc-name').value,
      phone: document.getElementById('calc-phone').value,
      email: document.getElementById('calc-email').value || 'leads@karmaveda.in',
      dob: activeMethod === 'birth'
        ? document.getElementById('calc-dob').value
        : document.getElementById('calc-dob-purpose').value,
      tob: activeMethod === 'birth'
        ? document.getElementById('calc-tob').value
        : document.getElementById('calc-tob-purpose').value,
      pob: activeMethod === 'birth'
        ? document.getElementById('calc-pob').value
        : document.getElementById('calc-pob-purpose').value
    };

    // Validate inputs
    const validationErrors = Calculator.validateInputs(formData);
    if (validationErrors.length > 0) {
      alert('Please fix the following errors:\n\n' + validationErrors.join('\n'));
      Calculator.setSubmitButtonState(false);
      return;
    }

    let selectedPurposes = [];

    if (activeMethod === 'birth') {
      const dob = document.getElementById('calc-dob').value;
      const pob = document.getElementById('calc-pob').value;
      if (!dob) {
        alert('Please enter your date of birth');
        Calculator.setSubmitButtonState(false);
        return;
      }
      if (!pob) {
        alert('Please enter your place of birth');
        Calculator.setSubmitButtonState(false);
        return;
      }
      const zodiac = Calculator.getZodiac(new Date(dob));
      selectedPurposes = zodiacData[zodiac].bracelets;
    } else {
      const checked = document.querySelectorAll('input[name="purposes"]:checked');
      const dob = document.getElementById('calc-dob-purpose').value;
      const pob = document.getElementById('calc-pob-purpose').value;
      if (checked.length === 0) {
        alert('Please select at least one purpose');
        Calculator.setSubmitButtonState(false);
        return;
      }
      if (!dob) {
        alert('Please enter your date of birth');
        Calculator.setSubmitButtonState(false);
        return;
      }
      if (!pob) {
        alert('Please enter your place of birth');
        Calculator.setSubmitButtonState(false);
        return;
      }
      selectedPurposes = Array.from(checked).map(cb => cb.value);
    }

    // Collect lead data
    const leadName = document.getElementById('calc-name').value;
    const leadPhone = document.getElementById('calc-phone').value;
    const leadEmail = document.getElementById('calc-email').value || 'leads@karmaveda.in';
    const leadDob = activeMethod === 'birth'
      ? document.getElementById('calc-dob').value
      : document.getElementById('calc-dob-purpose').value;
    const leadTob = activeMethod === 'birth'
      ? document.getElementById('calc-tob').value
      : document.getElementById('calc-tob-purpose').value;
    const leadPob = activeMethod === 'birth'
      ? document.getElementById('calc-pob').value
      : document.getElementById('calc-pob-purpose').value;

    const recommendedProducts = selectedPurposes.map(p => braceletData[p]?.handle || p).join(', ');

    // Submit lead
    Calculator.submitLead({
      name: leadName,
      phone: leadPhone,
      email: leadEmail,
      body: `Calculator Lead - Bracelet Calculator
================================
Name: ${leadName}
Phone: ${leadPhone}
Email: ${leadEmail}
Date of Birth: ${leadDob}
Time of Birth: ${leadTob || 'Not provided'}
Place of Birth: ${leadPob}
Method: ${activeMethod}
Selected Purposes: ${selectedPurposes.join(', ')}
Recommended Products: ${recommendedProducts}`
    });

    try {
      // Fetch all products from Shopify
      const productPromises = selectedPurposes.map(purpose =>
        fetch('/products/' + braceletData[purpose].handle + '.js')
          .then(res => res.ok ? res.json() : null)
          .catch(() => null)
      );

      const products = await Promise.all(productPromises);

      // Build results
      const resultsContainer = document.getElementById('bracelet-results');
      resultsContainer.textContent = '';

      selectedPurposes.forEach((purpose, index) => {
        const data = braceletData[purpose];
        const product = products[index];

        if (product) {
          product.handle = data.handle;

          if (typeof window.trackCalculatorResult === 'function') {
            window.trackCalculatorResult('bracelet', data.handle, purpose);
          }

          const card = Calculator.buildResultCard({
            badge: purposeLabels[purpose],
            product: product,
            subtitle: `Crystals: ${data.crystals}`,
            description: data.benefits,
            cardIndex: index
          });
          resultsContainer.appendChild(card);
        }
      });

      // Initialize handlers (bracelet has multiple products, so tracking handled in loop above)
      Calculator.initThumbnailHandlers(resultsContainer);
      Calculator.initCartHandlers(resultsContainer, {
        calculatorType: 'bracelet',
        productName: 'Healing Bracelet',
        productId: products[0]?.id || 'unknown'
      });

      // Show result, hide form
      document.querySelector('.calculator-page__form-section').style.display = 'none';
      document.getElementById('calculator-result').style.display = 'block';

      Calculator.setSubmitButtonState(false);

      // Scroll to result
      document.getElementById('calculator-result').scrollIntoView({ behavior: 'smooth', block: 'start' });

    } catch (error) {
      console.error('Error:', error);
      alert('Something went wrong. Please try again.');
      Calculator.setSubmitButtonState(false);
    }
  });
});
